import React from 'react';
import PropTypes from 'prop-types';

export default function MainTitle({ text, className, tag }) {
    return React.createElement(tag, { className: `main-title ${ className }` }, text);
}

MainTitle.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string.isRequired,
    tag: PropTypes.string,
};

MainTitle.defaultProps = {
    className: '',
    tag: 'h1',
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-title/index.js